import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FaDate from '../shared/FaDate';
import PresentAbsentSave from './PresentAbsentSave';
import ShowVideo from '../shared/ShowVideo';
import SchoolClassOperation from './SchoolClassOperation';
import TeacherNoteSave from './TeacherNoteSave';
import EduMonthCombo from '../combos/EduMonthCombo';
import TeacherSchoolClassCourseCombo from '../combos/TeacherSchoolClassCourseCombo';
import { Col, Form, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import SetDescribealbeScoreComments from './SetDescribealbeScoreComments';
import { useSearchParams } from "react-router-dom";


export default function TeacherScores(props) {
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [mainParamsVisible, setMainParamsVisible] = useState(false);
  const [scoresVisible, setScoresVisible] = useState(false);
  const [scores, setScores] = useState(null);
  const [scoresTitle, setScoresTitle] = useState(null);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [schoolClass, setSchoolClass] = useState({});
  const [course, setCourse] = useState({});
  const [searchMonth, setSearchMonth] = useState(null);
  const [month, setMonth] = useState(null);
  const [describealbeScoreCommentsVisible, setDescribealbeScoreCommentsVisible] = useState(false);
  const [positive, setPositive] = useState("");
  const [negative, setNegative] = useState("");
  const [recommend, setRecommend] = useState("");
  const [studentIndex, setStudentIndex] = useState(-1);
  const [studentName, setStudentName] = useState("");
  const [selectedScoreIndex, setSelectedScoreIndex] = useState(0);
  const [isAgent, setIsAgent] = useState(false);
  const [searchParams] = useSearchParams();


  useEffect(() => {
    var user = util.getCurrentUser();
    if(user.Role === 2 || user.Role === 3){
      const scId = searchParams.get("scId");
      const cId = searchParams.get("cId");
      const mInd = searchParams.get("mInd");
      console.log("(scId, cId, mInd)=>", scId, cId, mInd);
      var sch = JSON.parse(localStorage.getItem("CurrentSchoolClass"));
      var c = JSON.parse(localStorage.getItem("CurrentCourse"));
      console.log("sch=>", sch);
      console.log("c", c);
      setSchoolClass(sch);
      setCourse(c);
      setMonth({id:mInd, itemValue:{code:mInd}})
      setSearchMonth({id:mInd, itemValue:{code:mInd}})
      setIsAgent(true);
      setMainParamsVisible(true);
      showScores();   
      
    }
    else{
      setMainParamsVisible(true);
    }
    loadData();
  }, []);
  const loadData = function () {
  }
  const showScores = function (){
    if(!month) return;
    if(!schoolClass) return;
    if(!schoolClass.id) return;

    setLoading(true);
    var url = config.Server+`/school/teacher/student-scores/get`;
    var params = {login:util.getTrustedUser(), schoolClassId:schoolClass.id, courseId:course.id, monthInd:parseInt(month.id), isAgent:false};
    setLoading(true);
    axios
        .post(url, params )
        .then(res => {
          setLoading(false);
            var response = res.data;

            if(response.state === "ok"){
                
                response = response.data;
                restoreScores(response);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
            setLoading(false);
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });



    
  }
  const restoreScores = function (response){
        var sts = [
          {scoreDate:response.scoreDate1, title:"نمره " + "1", no:1},
          {scoreDate:response.scoreDate2, title:"نمره " + "2", no:2},
          {scoreDate:response.scoreDate3, title:"نمره " + "3", no:3},
          {scoreDate:response.scoreDate4, title:"نمره " + "4", no:4},
          {scoreDate:response.scoreDate5, title:"نمره " + "5", no:5},
          {scoreDate:response.scoreDate6, title:"نمره " + "6", no:6},
          {scoreDate:0, title:"نمره " + "نهائی ماهانه", no:7},
        ];
        for(var i=0;i<response.students.length;i++){
          response.students[i].scores = [
            {...response.students[i].score1},
            {...response.students[i].score2},
            {...response.students[i].score3},
            {...response.students[i].score4},
            {...response.students[i].score5},
            {...response.students[i].score6},
            {...response.students[i].final},
          ];
          for(var j=0;j<response.students[i].scores.length;j++){
            response.students[i].scores[j]["no"] = j+1;
            response.students[i].scores[j].scoreStr = "";
            response.students[i].scores[j]["positiveComment"] = "";
            response.students[i].scores[j]["negativeComment"] = "";
            response.students[i].scores[j]["recommendation"] = "";
            if(response.students[i].scores[j].isRegistered && response.students[i].scores[j].isPresent) {
              response.students[i].scores[j].scoreStr = String(response.students[i].scores[j].score);
              if((schoolClass.degree >=1) && (schoolClass.degree <=6)){

                    if(response.students[i].scores[j].score>util.describableScores.good){
                        response.students[i].scores[j]["positiveComment"] = response.students[i].scores[j]["positiveCommentVeryGood"];
                        response.students[i].scores[j]["negativeComment"] = response.students[i].scores[j]["negativeCommentVeryGood"];
                        response.students[i].scores[j]["recommendation"] = response.students[i].scores[j]["recommendationVeryGood"];
                    }
                    else if(response.students[i].scores[j].score>util.describableScores.acceptable){
                        response.students[i].scores[j]["positiveComment"] = response.students[i].scores[j]["positiveCommentGood"];
                        response.students[i].scores[j]["negativeComment"] = response.students[i].scores[j]["negativeCommentGood"];
                        response.students[i].scores[j]["recommendation"] = response.students[i].scores[j]["recommendationGood"];
                    }
                    else if(response.students[i].scores[j].score>util.describableScores.rejected){
                        response.students[i].scores[j]["positiveComment"] = response.students[i].scores[j]["positiveCommentAcceptable"];
                        response.students[i].scores[j]["negativeComment"] = response.students[i].scores[j]["negativeCommentAcceptable"];
                        response.students[i].scores[j]["recommendation"] = response.students[i].scores[j]["recommendationAcceptable"];
                    }
                    else {
                        response.students[i].scores[j]["positiveComment"] = response.students[i].scores[j]["positiveCommentRejected"];
                        response.students[i].scores[j]["negativeComment"] = response.students[i].scores[j]["negativeCommentRejected"];
                        response.students[i].scores[j]["recommendation"] = response.students[i].scores[j]["recommendationRejected"];
                    }

              }
            }
          }
        }  
        console.log("response is>", response);
        setSelectedScoreIndex(0);              
        setScores(response);
        setScoresTitle(sts);
        setScoresVisible(true);

  }
  const onComboChange = function(name, value){
    if(name === "searchMonth"){
      setMonth(value);
      setSearchMonth(value);
      console.log("value is>", value)
      if(value != month){
        setScoresVisible(false);
      }
    }
    return
  }
    const onInputChange = function(e, index, scoreIndex){
        var tmp = {...scores};
        var val = '';
        val = (e.target && e.target.value) || '';
        var v = val;
        if(v == null) v = "";
        tmp.students[index].scores[scoreIndex].scoreStr = v;
        if(v != ""){
          tmp.students[index].scores[scoreIndex].isPresent = true;
        }
        setScores(tmp);
    }
    const onCheckboxChange = (e, name, index, scoreIndex) => {
        var tmp = {...scores};
        if(name == "isPresent"){
            tmp.students[index].scores[scoreIndex].isPresent = !e.checked;
            if(e.checked){
              tmp.students[index].scores[scoreIndex].scoreStr = "";
            }
        }
        setScores(tmp);
    }
    const onScoreCheckboxChange = (e, score, index, scoreIndex) => {
        
        var tmp = {...scores};
        tmp.students[index].scores[selectedScoreIndex-1].scoreStr = String(score);
        tmp.students[index].scores[selectedScoreIndex-1].score = score;
        tmp.students[index].scores[selectedScoreIndex-1].isPresent = true;
        
        setScores(tmp);
    }
    const getCheckedState = function (index, target){
        if(!scores.students[index].scores[selectedScoreIndex-1].isPresent) return false;
        var score = scores.students[index].scores[selectedScoreIndex-1].score;
        if(score == 0) return false;
        if(target == 1){
            if(score == util.describableScores.veryGood)return true;
            else return false;
        }
        else if(target == 2){
            if((score==util.describableScores.good)) return true;
            else return false;
        }
        else if(target == 3){
            if((score==util.describableScores.acceptable)) return true;
            else return false;
        }
        else if(target == 4){
            if(score == util.describableScores.rejected) return true;
            else return false;
        }

        return false;
    }
    const onSetDescribleableScoreComments = function(index, positiveStr, negativeStr, recommendStr){
        var tmp = {...scores};
        tmp.students[index].scores[selectedScoreIndex-1].positiveComment = positiveStr;
        tmp.students[index].scores[selectedScoreIndex-1].negativeComment = negativeStr;
        tmp.students[index].scores[selectedScoreIndex-1].recommendation = recommendStr;
        setScores(tmp);
        setDescribealbeScoreCommentsVisible(false);
    }
    const showSetDescribleableScoreCommentsForm = function(index, scoreIndex){
        var row = scores.students[index];
        setPositive(row.scores[selectedScoreIndex-1].positiveComment.trim());
        setNegative(row.scores[selectedScoreIndex-1].negativeComment.trim());
        setRecommend(row.scores[selectedScoreIndex-1].recommendation.trim());
        setStudentIndex(index);
        setStudentName("[" + row.student.nationalId + "] " + row.student.firstname + " " + row.student.lastname);
        setDescribealbeScoreCommentsVisible(true);

    }
    const createScoreGetter = function(row, index, scoreIndex){
        var color = "#ee4444";
        if((row.positiveComment.trim() != "")||(row.negativeComment.trim() != "")||(row.recommendation.trim() != ""))color = "#44ee44";
        return(
            <>
                <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                    <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.veryGood, index, scoreIndex)}} checked={getCheckedState(index, 1)} />
                </td>                
                <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                    <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.good, index, scoreIndex)}} checked={getCheckedState(index, 2)} />
                </td>                
                <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                    <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.acceptable, index, scoreIndex)}} checked={getCheckedState(index, 3)} />
                </td>                
                <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                    <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.rejected, index, scoreIndex)}} checked={getCheckedState(index, 4)} />
                </td>                
                <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                    <div onClick={()=>{showSetDescribleableScoreCommentsForm(index, scoreIndex)}} style={{width:"20px", height:"20px", backgroundColor:color, borderRadius:"50%"}}></div>
                </td>                
            </>
        )

    }
    const saveScores = function(){
      var tmp = scores.students;
      var students = [];
      for(var i=0;i<tmp.length;i++){
        var hasScore = true;
        if(tmp[i].scores[selectedScoreIndex - 1].scoreStr == null) tmp[i].scores[selectedScoreIndex - 1].scoreStr = "";
        if(tmp[i].scores[selectedScoreIndex - 1].scoreStr == "") hasScore = false;
        if(!util.IsNumber(tmp[i].scores[selectedScoreIndex - 1].scoreStr)) hasScore = false;

        var isPresent = tmp[i].scores[selectedScoreIndex - 1].isPresent;
        var isRegistered = false;
        var score = 0;
        var positiveCommentVeryGood = "";
        var negativeCommentVeryGood = "";
        var recommendationVeryGood = "";
        var positiveCommentGood = "";
        var negativeCommentGood = "";
        var recommendationGood = "";
        var positiveCommentAcceptable = "";
        var negativeCommentAcceptable = "";
        var recommendationAcceptable = "";
        var positiveCommentRejected = "";
        var negativeCommentRejected = "";
        var recommendationRejected = "";
        if(isPresent){
          if(hasScore){
            isRegistered = true;
            score = parseFloat(tmp[i].scores[selectedScoreIndex - 1].scoreStr);
            if(score <= 0) {              
              if((schoolClass.degree >=1) && (schoolClass.degree <=6)) score = util.describableScores.rejected
              else score = 0.01;
            }
          }
          else{
            score = 0;
            isRegistered = false
          }
        }
        else{
          isRegistered = true;
          score = 0;
        }
        // if(i == 0){
        //   console.log("hasScore is>", hasScore);
        //   console.log("isRegistered is>", isRegistered);
        //   console.log("score is>", score);
        //   console.log("tmp[i].scores[selectedScoreIndex - 1].scoreStr is>", tmp[i].scores[selectedScoreIndex - 1].scoreStr);
        //   return;
        // }
        if((schoolClass.degree >=1) && (schoolClass.degree <=6)){
            if(isPresent){
                if(hasScore){
                    if(score>util.describableScores.good){
                        positiveCommentVeryGood = tmp[i].scores[selectedScoreIndex - 1].positiveComment;
                        negativeCommentVeryGood = tmp[i].scores[selectedScoreIndex - 1].negativeComment;
                        recommendationVeryGood = tmp[i].scores[selectedScoreIndex - 1].recommendation;
                    }
                    else if(score>util.describableScores.acceptable){
                        positiveCommentGood = tmp[i].scores[selectedScoreIndex - 1].positiveComment;
                        negativeCommentGood = tmp[i].scores[selectedScoreIndex - 1].negativeComment;
                        recommendationGood = tmp[i].scores[selectedScoreIndex - 1].recommendation;
                    }
                    else if(score>util.describableScores.rejected){
                        positiveCommentAcceptable = tmp[i].scores[selectedScoreIndex - 1].positiveComment;
                        negativeCommentAcceptable = tmp[i].scores[selectedScoreIndex - 1].negativeComment;
                        recommendationAcceptable = tmp[i].scores[selectedScoreIndex - 1].recommendation;
                    }else{
                        positiveCommentRejected = tmp[i].scores[selectedScoreIndex - 1].positiveComment;
                        negativeCommentRejected = tmp[i].scores[selectedScoreIndex - 1].negativeComment;
                        recommendationRejected = tmp[i].scores[selectedScoreIndex - 1].recommendation;
                    }
                }
                else{
                    positiveCommentVeryGood = "";
                    negativeCommentVeryGood = "";
                    recommendationVeryGood = "";
                    positiveCommentGood = "";
                    negativeCommentGood = "";
                    recommendationGood = "";
                    positiveCommentAcceptable = "";
                    negativeCommentAcceptable = "";
                    recommendationAcceptable = "";
                    positiveCommentRejected = "";
                    negativeCommentRejected = "";
                    recommendationRejected = "";
                }
            }
            else{
                positiveCommentVeryGood = "";
                negativeCommentVeryGood = "";
                recommendationVeryGood = "";
                positiveCommentGood = "";
                negativeCommentGood = "";
                recommendationGood = "";
                positiveCommentAcceptable = "";
                negativeCommentAcceptable = "";
                recommendationAcceptable = "";
                positiveCommentRejected = "";
                negativeCommentRejected = "";
                recommendationRejected = "";
            }
        }
        else{
            if(hasScore) {
                if(parseFloat(tmp[i].scores[selectedScoreIndex - 1].scoreStr)>20){
                    setErrorMessage("نمره نمی تواند بیشتر از 20 باشد");
                    setErorVisible(true);
                    setSaving(false);
                    return;
                }
            }

        }
        students.push({
            studentId:tmp[i].student.id, 
            isRegistered:isRegistered, 
            isPresent:isPresent, 
            score:score,
            positiveCommentVeryGood:positiveCommentVeryGood,
            negativeCommentVeryGood:negativeCommentVeryGood,
            recommendationVeryGood:recommendationVeryGood,
            positiveCommentGood:positiveCommentGood,
            negativeCommentGood:negativeCommentGood,
            recommendationGood:recommendationGood,
            positiveCommentAcceptable:positiveCommentAcceptable,
            negativeCommentAcceptable:negativeCommentAcceptable,
            recommendationAcceptable:recommendationAcceptable,
            positiveCommentRejected:positiveCommentRejected,
            negativeCommentRejected:negativeCommentRejected,
            recommendationRejected:recommendationRejected,
        });
      }
      var url = config.Server+`/school/teacher/continual-scores/save`;
      var params = {login:util.getTrustedUser(), courseId:course.id, schoolClassId:schoolClass.id, testDate:0, monthInd:parseInt(month.id), scoreInd:selectedScoreIndex, students:students};
      setSaving(true);
      console.log("save param is>", params);
      console.log("save url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              console.log("save response is>", response);
              if(response.state === "ok"){
                  setSaving(false);
                  setSelectedScoreIndex(0);
                  showScores();
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
        
    }
    const saveAverageScores = function(){
      var tmp = scores.students;
      var students = [];
      var url = config.Server+`/school/teacher/continual-scores/save-average`;
      var params = {login:util.getTrustedUser(), courseId:course.id, schoolClassId:schoolClass.id, testDate:0, monthInd:parseInt(month.id), scoreInd:selectedScoreIndex, students:students};
      setSaving(true);
      console.log("save param is>", params);
      console.log("save url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              console.log("save response is>", response);
              if(response.state === "ok"){
                  setSaving(false);
                  //setSelectedScoreIndex(0);
                  //showScores();
                  response = response.data;
                  restoreScores(response);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
        
    }
  return (
    <>
      <ShowVideo videoId="teacher_notes" top={65} md={6} />
    <div>
      
      {
        mainParamsVisible?
        <>
          <div className="" style={{ width:"calc(100% - 0px)"}}>
            <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
                <Row>
                  <Col md={3}>
                    <TeacherSchoolClassCourseCombo schoolClassId={schoolClass==null? "":schoolClass.id} courseId={course==null?"" : course.id} onChange={(value)=>{console.log(value); setSchoolClass(value.schoolClass); setCourse(value.course); setScoresVisible(false);}} />
                  </Col>
                  <Col md={3}>
                    <EduMonthCombo returnFullItem={true} value={searchMonth} onChange={(val) => onComboChange('searchMonth', val)} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right"}}>
                      <Button label="مشاهده نمرات" icon="pi pi-search" onClick={()=>showScores()} severity="primary" iconPos="right" loading={loading} />
                    </div>
                    
                  </Col>
                </Row>
            </div>
          </div>
        
        </>
        :
        <>در حال بارگزاری...</>
      }

      {
        scoresVisible ?
          <>
            <div style={{backgroundColor:'rgb(247, 253, 241)', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root', marginTop:"15px"}}>
              <Row style={{marginTop:"5px"}}><Col md={12}>ماه: <span style={{backgroundColor:"#151596", color:"#ffffff", padding:"3px 10px", borderRadius:"3px"}}>{month.id}</span></Col></Row>
              <Row style={{marginTop:"5px"}}><Col md={12}>کلاس: {schoolClass.name}</Col></Row>
              <Row style={{marginTop:"5px"}}><Col md={12}>درس: {course.name}</Col></Row>
              <Row>
                <Col md={12}>
                  <table>
                    <tbody>
                      <tr><td colSpan={5} style={{padding:"5px"}}>جهت ویرایش نمره مورد نطر، شماره آن را در کادرهای زیر انتخاب کنید</td></tr>
                      <tr>
                        <td style={{padding:"5px"}}><div onClick={()=>{setSelectedScoreIndex(1)}} style={{cursor:"pointer", backgroundColor:(selectedScoreIndex==1?"#151596":"#ffffff"), color:(selectedScoreIndex==1?"#ffffff":"#000000"), width:"40px", height:"35px", paddingTop:"5px", textAlign:"center", border:"2px solid #b0b0b0", borderRadius:"5px"}}>1</div></td>
                        <td style={{padding:"5px"}}><div onClick={()=>{setSelectedScoreIndex(2)}} style={{cursor:"pointer", backgroundColor:(selectedScoreIndex==2?"#151596":"#ffffff"), color:(selectedScoreIndex==2?"#ffffff":"#000000"), width:"40px", height:"35px", paddingTop:"5px", textAlign:"center", border:"2px solid #b0b0b0", borderRadius:"5px"}}>2</div></td>
                        <td style={{padding:"5px"}}><div onClick={()=>{setSelectedScoreIndex(3)}} style={{cursor:"pointer", backgroundColor:(selectedScoreIndex==3?"#151596":"#ffffff"), color:(selectedScoreIndex==3?"#ffffff":"#000000"), width:"40px", height:"35px", paddingTop:"5px", textAlign:"center", border:"2px solid #b0b0b0", borderRadius:"5px"}}>3</div></td>
                        <td style={{padding:"5px"}} rowSpan={2}><div onClick={()=>{setSelectedScoreIndex(7)}} style={{cursor:"pointer", backgroundColor:(selectedScoreIndex==7?"#151596":"#ffffff"), color:(selectedScoreIndex==7?"#ffffff":"#000000"), width:"80px", height:"80px", paddingTop:"25px", textAlign:"center", border:"2px solid #b0b0b0", borderRadius:"5px"}}>نهائی</div></td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr>
                        <td style={{padding:"5px"}}><div onClick={()=>{setSelectedScoreIndex(4)}} style={{cursor:"pointer", backgroundColor:(selectedScoreIndex==4?"#151596":"#ffffff"), color:(selectedScoreIndex==4?"#ffffff":"#000000"), width:"40px", height:"35px", paddingTop:"5px", textAlign:"center", border:"2px solid #b0b0b0", borderRadius:"5px"}}>4</div></td>
                        <td style={{padding:"5px"}}><div onClick={()=>{setSelectedScoreIndex(5)}} style={{cursor:"pointer", backgroundColor:(selectedScoreIndex==5?"#151596":"#ffffff"), color:(selectedScoreIndex==5?"#ffffff":"#000000"), width:"40px", height:"35px", paddingTop:"5px", textAlign:"center", border:"2px solid #b0b0b0", borderRadius:"5px"}}>5</div></td>
                        <td style={{padding:"5px"}}><div onClick={()=>{setSelectedScoreIndex(6)}} style={{cursor:"pointer", backgroundColor:(selectedScoreIndex==6?"#151596":"#ffffff"), color:(selectedScoreIndex==6?"#ffffff":"#000000"), width:"40px", height:"35px", paddingTop:"5px", textAlign:"center", border:"2px solid #b0b0b0", borderRadius:"5px"}}>6</div></td>
                        <td>&nbsp;</td>
                      </tr>
                      {
                        selectedScoreIndex == 7?
                      <tr>
                        <td style={{padding:"5px", direction:"ltr", textAlign:"right"}} colSpan={4}>
                          <Button label="ثبت میانگین 6 نمره برای نمره نهائی ماه" icon="pi pi-check" onClick={()=>saveAverageScores()} severity="primary" iconPos="right" loading={saving} />
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                        :
                        <></>
                      }
                    </tbody>
                  </table>
                </Col>
              </Row>
              <Row><Col md={12}><hr/></Col></Row>
              <Row>
                  <Col md={12}>
                    نمره 0 قابل ثبت نیست و به جای آن می توانید از عدد 0.01 استفاده کنید
                  </Col>
              </Row>
              <Row><Col md={12}><hr/></Col></Row>
              {
                ((schoolClass.degree >=1) && (schoolClass.degree <=6))?
                <>
                  <div style={{width:"100%", overflowX:"scroll"}}>
                  <Row>
                    <Col md={12}>
                        <table style={{width:"100%", borderCollapse:"collapse"}}>
                            <thead>
                                <tr>
                                    <th rowSpan={2} style={{width:"20px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"middle"}}>#</th>
                                    <th rowSpan={2} style={{width:"100px", backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0", verticalAlign:"middle"}}>کد ملی</th>
                                    <th rowSpan={2} style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0", verticalAlign:"middle"}}>نام و نام خانوادگی</th>
                                    {
                                      (selectedScoreIndex>0)&&((!isAgent)||(selectedScoreIndex==7))?
                                        <th colSpan={6} style={{textAlign:"center", width:"35px", backgroundColor:"#151596", color:"#ffffff", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"middle"}}>
                                            {selectedScoreIndex==7 ? "نهائی ماه" + " "+ month.id : selectedScoreIndex}
                                        </th>
                                        :
                                        <></>
                                    }
                                    {
                                      scoresTitle.map((st, stInd)=>{
                                        return(
                                          <>
                                            <th colSpan={1} style={{textAlign:"center", width:"35px", backgroundColor:"#e5e5e5", color:"#000000", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"middle"}}>
                                                {st.no==7 ? "نهائی ماه" + " "+ month.id : st.no}
                                            </th>
                                          </>
                                        )
                                      })
                                    }
                                </tr>
                                <tr style={{height:"80px"}}>
                                    {
                                      (selectedScoreIndex>0)&&((!isAgent)||(selectedScoreIndex==7))?
                                        <>
                                        <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"bottom"}}>
                                            غایب
                                        </th>
                                        <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                            <div style={{transform:"rotate(270deg)", position:"absolute", top:"20px", left:"-30px", width:"90px", textAlign:"left"}}>خیلی خوب</div>                                    
                                        </th>
                                        <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                            <div style={{transform:"rotate(270deg)", position:"absolute", top:"20px", left:"-30px", width:"90px", textAlign:"left"}}>خوب</div>                                    
                                        </th>
                                        <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                            <div style={{transform:"rotate(270deg)", position:"absolute", top:"20px", left:"-30px", width:"90px", textAlign:"left"}}>قابل قبول</div>                                    
                                        </th>
                                        <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                            <div style={{transform:"rotate(270deg)", position:"absolute", top:"10px", left:"-45px", width:"120px", textAlign:"left"}}>نیاز به تلاش</div>                                    
                                        </th>
                                        <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                            <div style={{transform:"rotate(270deg)", position:"absolute", top:"20px", left:"-30px", width:"90px", textAlign:"left"}}>نظر</div>                                    
                                        </th>
                                        </>
                                        :
                                        <></>
                                    }
                                    {
                                      scoresTitle.map((st, stInd)=>{
                                        return(
                                            <>
                                            <th style={{minWidth:"70px", width:"90px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"middle", textAlign:"center"}}>
                                                نمره
                                            </th>
                                            </>
                                        )
                                      })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    scores.students.map((row, index)=>{
                                        return(
                                        <tr>
                                            <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{(index+1)}</td>
                                            <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.nationalId}</td>
                                            <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.firstname + " " + row.student.lastname}</td>
                                            {
                                              (selectedScoreIndex>0)&&((!isAgent)||(selectedScoreIndex==7))?
                                                <>
                                                {
                                                  row.scores.map((sc, scInd)=>{
                                                    return(
                                                      <>
                                                      {
                                                        (selectedScoreIndex == sc.no)?
                                                        <>
                                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                                            <Checkbox onChange={(e)=>{onCheckboxChange(e, "isPresent", index, scInd)}} checked={!scores.students[index].scores[scInd].isPresent} />
                                                        </td>

                                                        {createScoreGetter(sc, index)}
                                                        </>
                                                        :
                                                        <></>
                                                      }
                                                      </>
                                                    )
                                                  })
                                                }
                                                </>
                                                :
                                                <></>
                                            }
                                            {
                                              row.scores.map((sc, scInd)=>{
                                                return(
                                                    <>
                                                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                                        {
                                                          sc.isRegistered?
                                                          <>{sc.isPresent? util.getScore(schoolClass.degree, sc.score) : "غ"}</>
                                                          :
                                                          <>?</>
                                                        }
                                                    </td>
                                                    </>
                                                )
                                              })
                                            }
                                        </tr>
                                        )
                                    })
                                }
                                <tr><td colSpan={5}>&nbsp;</td></tr>
                            </tbody>
                        </table>
                    
                    </Col>
                  </Row>
                  </div>
                </>
                :
                <></>
              }
              {
                ((schoolClass.degree >=1) && (schoolClass.degree <=6))?
                <></>
                :
                <>
                <div style={{width:"100%", overflowX:"scroll"}}>
                  <Row>
                    <Col md={12}>
                        <table style={{width:"100%", borderCollapse:"collapse"}}>
                            <thead>
                                <tr style={{height:"60px"}}>
                                    <th rowSpan={2} style={{width:"20px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"middle"}}>#</th>
                                    <th rowSpan={2} style={{width:"100px", backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0", verticalAlign:"middle"}}>کد ملی</th>
                                    <th rowSpan={2} style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0", verticalAlign:"middle"}}>نام و نام خانوادگی</th>
                                    {
                                      (selectedScoreIndex>0)&&((!isAgent)||(selectedScoreIndex==7))?
                                        <th colSpan={2} style={{textAlign:"center", width:"35px", backgroundColor:"#151596", color:"#ffffff", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"middle"}}>
                                            {selectedScoreIndex==7 ? "نهائی ماه" + " "+ month.id : selectedScoreIndex}
                                        </th>
                                        :
                                        <></>
                                    }
                                    {
                                      scoresTitle.map((st, stInd)=>{
                                        return(
                                          <>
                                            <th colSpan={1} style={{textAlign:"center", width:"35px", backgroundColor:"#e5e5e5", color:"#000000", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"middle"}}>
                                                {st.no==7 ? "نهائی ماه" + " "+ month.id : st.no}
                                            </th>
                                          </>
                                        )
                                      })
                                    }
                                </tr>
                                <tr>
                                    {
                                      (selectedScoreIndex>0)&&((!isAgent)||(selectedScoreIndex==7))?
                                        <>
                                          <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"bottom"}}>
                                              غایب
                                          </th>
                                          <th style={{minWidth:"70px", width:"180px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"middle", textAlign:"center"}}>
                                              نمره
                                          </th>
                                        </>
                                        :
                                        <></>
                                    }
                                    {
                                      scoresTitle.map((st, stInd)=>{
                                        return(
                                          <>
                                          <th style={{minWidth:"70px", width:"90px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", borderLeft:"1px solid #d0d0d0", borderRight:"1px solid #d0d0d0", verticalAlign:"middle", textAlign:"center"}}>
                                              نمره
                                          </th>
                                          </>
                                        )
                                      })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    scores.students.map((row, index)=>{
                                        return(
                                        <tr>
                                            <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{(index+1)}</td>
                                            <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.nationalId}</td>
                                            <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.firstname + " " + row.student.lastname}</td>
                                            {
                                              (selectedScoreIndex>0)&&((!isAgent)||(selectedScoreIndex==7))?
                                                <>
                                                {
                                                  row.scores.map((sc, scInd)=>{
                                                    return(
                                                      <>
                                                      {
                                                        (selectedScoreIndex == sc.no)?
                                                        <>
                                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                                            <Checkbox onChange={(e)=>{onCheckboxChange(e, "isPresent", index, scInd)}} checked={!scores.students[index].scores[scInd].isPresent} />
                                                        </td>
                                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                                            <InputText keyfilter={"num"} value={scores.students[index].scores[scInd].scoreStr} onChange={(e) => onInputChange(e, index, scInd)} maxLength={5} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}}/>
                                                        </td>                
                                                        </>
                                                        :
                                                        <></>
                                                      }
                                                      </>
                                                    )
                                                  })
                                                }
                                                </>
                                                :
                                                <></>
                                            }
                                            {
                                              row.scores.map((sc, scInd)=>{
                                                return(
                                                  <>
                                                  <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                                      {
                                                        sc.isRegistered?
                                                        <>{sc.isPresent? util.getScore(schoolClass.degree, sc.score) : "غ"}</>
                                                        :
                                                        <>?</>
                                                      }
                                                  </td>
                                                  </>
                                                )
                                              })
                                            }
                                        </tr>
                                        )
                                    })
                                }
                                <tr><td colSpan={5}>&nbsp;</td></tr>
                            </tbody>
                        </table>
                    
                    </Col>
                  </Row>
                </div>
                </>
              }
              {
                ((selectedScoreIndex>0)&&((!isAgent)||(selectedScoreIndex==7)))?
                <Row style={{marginTop:"20px"}}>
                  <Col md={12}>
                    <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right"}}>
                      <Button label="ثبت نمرات" icon="pi pi-check" onClick={()=>saveScores()} severity="success" iconPos="right" loading={saving} />
                    </div>
                  </Col>
                </Row>
                :
                <></>

              }
            </div>
          </>
          :
          <></>
      }
        {
        describealbeScoreCommentsVisible?
        <SetDescribealbeScoreComments onAccept={(index, positiveStr, negativeStr, recommendStr)=>{onSetDescribleableScoreComments(index, positiveStr, negativeStr, recommendStr)}} index={studentIndex} studentName={studentName} positiveComment={positive} negativeComment={negative} recommendation={recommend} onClose={()=>{setDescribealbeScoreCommentsVisible(false)}} />
        :
        <></>
        }

      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
    </div>
    </>
  );
}
